import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/caso-llantas-cavazos-migracion-shopify")({
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos/caso-llantas-cavazos-migracion", statusCode: 301 });
  },
});
